import { Component, Input } from '@angular/core';
import { siteSubscriptions } from '@services/siteSubscriptions';

/**
 * Default Class Component
 */
@Component({
	selector: 'app-application-name',
	templateUrl: './application-name.component.html',
	styleUrls: ['./application-name.component.scss']
})
export class ApplicationNameComponent {
	/** inputValue */
	@Input() inputValue: string;
	/** foreColor */
	@Input() foreColor: string;
	/** styleString */
	@Input() styleString: string;
	/** classString */
	@Input() classString: string;

	/**
	 * Default Constructor
	 * @param siteSubscriptions siteSubscriptions
	 */
	constructor(
		private siteSubscriptions: siteSubscriptions //Site Subscription
	) {

	}
}
